import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext({ theme: "soft", setTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => localStorage.getItem("ss_theme") || "soft");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "night") root.classList.add("night");
    else root.classList.remove("night");
    localStorage.setItem("ss_theme", theme);
  }, [theme]);

  const setTheme = useCallback((t) => setThemeState(t === "night" ? "night" : "soft"), []);

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
